<template>
  <div>
    <div class="luminance-page" v-if="answerData">
      <div class="bg"></div>
      <div class="content" :key="index" v-for="(item, index) in answerData">
        <div class="luminanceTop">
          <div class="left">
            <img src="./../../assets/microscope/selectIcon.png" alt="" /><span
              >玻片{{ index + 1 }}：</span
            >
          </div>
          <div class="right">
            <div class="imgBox">
              <div>
                <span>A</span><img :src="item.lowImage1" alt="" srcset="" />
              </div>
              <div>
                <span>B</span><img :src="item.lowImage2" alt="" srcset="" />
              </div>
              <div>
                <span>C</span><img :src="item.lowImage3" alt="" srcset="" />
              </div>
              <div>
                <span>D</span><img :src="item.lowImage4" alt="" srcset="" />
              </div>

              <!-- <img :src="item.lowImage1" alt="" srcset="" />
              <img :src="item.lowImage2" alt="" srcset="" />
              <img :src="item.lowImage3" alt="" srcset="" />
              <img :src="item.lowImage4" alt="" srcset="" /> -->
            </div>
          </div>
        </div>
        <div class="box">
          <div
            class="choose-box"
            :key="idx"
            v-for="(itm, idx) in item.questionList"
          >
            <div class="choose-text">
              <div>题目{{ idx + 1 }}.</div>
              <div>{{ itm.title }}</div>
            </div>
            <div
              :class="
                itm.answers.indexOf(itmItem.value) != -1 ? 'choose-active' : ''
              "
              class="choose-list"
              v-for="(itmItem, idxIndex) in itm.optionList"
              :key="idxIndex"
            >
              <p>{{ itmItem.value }}</p>
              <div>{{ itmItem.content }}</div>
            </div>
            <div class="answerSelect">
              <div class="txt">您的作答为：{{ itm.userAnswers }}</div>
              <div class="txt">
                正确答案为：<span>{{ itm.answers }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer">
        <div @click="handleBtn" class="btn">返回</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getSlideAnswer } from "@/api/system/exam";
export default {
  name: "Home2026",
  data() {
    return {
      answerData: null,
      fromPath: null,
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fromPath = from.path; //获取上一级路由的路径
    });
  },
  created() {
    this.init();
  },

  methods: {
    // 返回上一步
    handleBtn() {
      // this.$router.replace(this.fromPath)
      this.$router.back();
      // this.$router.replace(this.fromPath)
    },

    // 初始化
    init() {
      getSlideAnswer().then((res) => {
        if (res.data.code === 0) {
          this.answerData = res.data.data;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.luminance-page {
  width: 100%;
  min-height: 100vh;
  background-image: url("./../../assets/home/xwjBg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  .bg {
    height: 100px;
  }
  .content {
    width: 653px;
    border-radius: 60px;
    margin: 0 auto;
    .luminanceTop {
      width: 653px;
      height: 402px;
      background: rgba(255, 255, 255, 0.85);
      border: 2px solid #ffffff;
      border-radius: 60px;
      box-shadow: 0px 30px 70px 0px rgba(13, 96, 103, 0.38);
      margin: 0 auto;
      display: flex;
      justify-content: center;
      .left {
        margin-left: 22px;
        font-size: 35px;
        font-family: HarmonyOS Sans SC;
        font-weight: bold;
        color: #333333;
        line-height: 402px;
        img {
          width: 30px;
          height: 28px;
          vertical-align: middle;
          margin-right: 18px;
        }
      }
      .right {
        padding: 20px 20px 20px 0;
        .imgBox {
          width: 434px;
          margin: 0 auto;
          margin-top: 10px;
          display: flex;
          flex-wrap: wrap;
          border-radius: 48px;
          overflow: hidden;
          // img {
          //   width: 50%;
          // }
          div {
            width: 50%;
            height: 170px;
            position: relative;
            box-sizing: border-box;
            span {
              position: absolute;
              left: 10px;
              bottom: 10px;
              font-size: 50px;
              color: #000;
              z-index: 2;
            }
            img {
              width: 100%;
              height: 100%;
              position: absolute;
              // height: 102px;
            }
          }
          div:nth-child(1) {
            border-bottom: 3px solid #ab3b91;
            border-right: 3px solid #ab3b91;
          }
          div:nth-child(2) {
            border-bottom: 3px solid #ab3b91;
          }
          div:nth-child(3) {
            border-right: 3px solid #ab3b91;
          }
        }
      }
    }
    .box {
      width: 653px;
      background: rgba(255, 255, 255, 0.3);
      box-shadow: 0px 30px 70px 0px rgba(13, 96, 103, 0.65);
      border-radius: 60px;
      margin-top: 32px;
      margin-bottom: 143px;
      .choose-box {
        padding: 40px 45px 45px 45px;
        .choose-text {
          font-size: 35px;
          font-family: HarmonyOS Sans SC;
          font-weight: bold;
          color: #333333;
          line-height: 50px;
        }
        .choose-list {
          height: auto;
          width: 440px;
          background: #ffffff;
          box-shadow: 2px 3px 5px 0px rgba(14, 89, 145, 0.11);
          border-radius: 40px;
          margin-top: 20px;
          font-size: 25px;
          font-family: HarmonyOS Sans SC;
          font-weight: 400;
          color: #4d4d4d;
          display: flex;
          align-items: center;
          padding: 0 61px;
          p {
            position: relative;
            margin-right: 19px;
          }
          p::before {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            left: 39px;
            content: "";
            width: 2px;
            height: 38px;
            background: #cccccc;
          }
          div {
            margin-left: 35px;
          }
        }
        .choose-active {
          box-shadow: 2px 3px 5px 0px rgba(14, 89, 145, 0.11);
          background: #ab3b91;
          color: #fff;
        }
        .choose-active > p::before {
          background: #fff;
        }
        .answerSelect {
          margin-top: 74px;
          .txt {
            font-size: 30px;
            font-family: HarmonyOS Sans SC;
            font-weight: 500;
            color: #fefefe;
            text-align: center;
            span {
              color: #ab3b91;
            }
          }
        }
      }
    }
  }
  .footer {
    position: fixed;
    bottom: 0;
    width: 570px;
    height: 143px;
    background: linear-gradient(0deg, #ffffff, #e9f4f2);
    box-shadow: 0px -5px 50px 0px rgba(84, 84, 84, 0.07);
    border-radius: 60px 60px 0px 0px;
    padding: 40px 90px 0 90px;
    display: flex;
    .btn {
      width: 514px;
      height: 88px;
      background: linear-gradient(
        132.74deg,
        rgba(0, 187, 177, 1) 0%,
        rgba(0, 86, 140, 1) 74.31%,
        rgba(171, 59, 127, 1) 100%
      );
      border: 1px solid #ffffff;
      box-shadow: 0px 0px 10px 0px rgba(36, 36, 36, 0.29);
      line-height: 88px;
      border-radius: 44px;
      font-size: 35px;
      font-family: HarmonyOS Sans SC;
      font-weight: 500;
      color: #ffffff;
      text-align: center;
      margin: 0 auto;
      img {
        width: 35px;
        margin-right: 25px;
        vertical-align: middle;
      }
    }
  }
  .mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    background: rgba(255, 255, 255, 0.8);
  }
  .dialog {
    width: 665px;
    height: 642px;
    position: fixed;
    z-index: 2;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    background: #ffffff;
    box-shadow: 0px 30px 70px 0px rgba(13, 96, 103, 0.65);
    border-radius: 60px;
    .title {
      height: 60px;
      font-size: 65px;
      font-family: HarmonyOS Sans SC;
      font-weight: bold;
      color: #ab3b91;
      text-align: center;
      margin-top: 100px;
    }
    .text {
      font-size: 35px;
      font-family: HarmonyOS Sans SC;
      font-weight: bold;
      color: #333333;
      line-height: 60px;
      text-align: center;
    }
    .mt100 {
      margin-top: 100px;
    }
    .flex {
      display: flex;
      padding: 120px 50px 0 50px;
      .btn {
        width: 260px;
        margin: 0 auto;
        height: 80px;
        line-height: 80px;
        text-align: center;
        font-size: 35px;
        font-family: HarmonyOS Sans SC;
        font-weight: 500;
        color: #ffffff;
        border-radius: 40px;
        background: linear-gradient(
          132.74deg,
          rgba(0, 187, 177, 1) 0%,
          rgba(0, 86, 140, 1) 74.31%,
          rgba(171, 59, 127, 1) 100%
        );
      }
    }
  }
}
</style>
